export default __webpack_public_path__ + "static/media/higher_icon_blockchain_reversed.9f09126a.svg";